import React from 'react';

export type DatePickerHeaderProps = {
    monthDate: Date;
    customHeaderCount: number;
    decreaseMonth: () => void;
    increaseMonth: () => void;
    minDate: Date;
    maxDate: Date;
};

const CustomDatePickerHeader: React.FC<DatePickerHeaderProps> = (props: DatePickerHeaderProps) => {
    const { monthDate, customHeaderCount, decreaseMonth, increaseMonth, minDate, maxDate } = props;

    const YEAR_MONTH_BASE = 100;
    const JANUARY_INDEX = 0;
    const DECEMBER_INDEX = 11;

    // Extract year and month from the dates
    const currentHeaderYear = monthDate.getFullYear();
    const currentHeaderMonth = monthDate.getMonth();

    const minYear = minDate.getFullYear();
    const minMonth = minDate.getMonth();

    const maxYear = maxDate.getFullYear();
    const maxMonth = maxDate.getMonth();

    // Calculate year-month values for comparison (e.g., 202403 for March 2024)
    const minYearMonth = minYear * YEAR_MONTH_BASE + minMonth;
    const maxYearMonth = maxYear * YEAR_MONTH_BASE + maxMonth;

    // Determine if previous navigation should be disabled
    const prevYearMonth = currentHeaderMonth === JANUARY_INDEX
        ? (currentHeaderYear - 1) * YEAR_MONTH_BASE + DECEMBER_INDEX // December of previous year
        : currentHeaderYear * YEAR_MONTH_BASE + (currentHeaderMonth - 1);

    const prevMonthBtnDisabled = prevYearMonth < minYearMonth;

    // Determine if next navigation should be disabled
    const nextYearMonth = currentHeaderMonth === DECEMBER_INDEX
        ? (currentHeaderYear + 1) * YEAR_MONTH_BASE + JANUARY_INDEX // January of next year
        : currentHeaderYear * YEAR_MONTH_BASE + (currentHeaderMonth + 1);

    const nextMonthBtnDisabled = nextYearMonth > maxYearMonth;

    return (
        <div>
            <button
                aria-label="Previous Month"
                className='react-datepicker__navigation react-datepicker__navigation--previous'
                style={customHeaderCount === 1 ? { visibility: 'hidden' } : null}
                onClick={decreaseMonth}
                disabled={prevMonthBtnDisabled}
            >
                <span className='react-datepicker__navigation-icon react-datepicker__navigation-icon--previous'>
                    {'<'}
                </span>
            </button>
            <span className='react-datepicker__current-month'>
                {monthDate.toLocaleString('en-US', { month: 'long', year: 'numeric' })}
            </span>
            <button
                aria-label="Next Month"
                className='react-datepicker__navigation react-datepicker__navigation--next'
                style={customHeaderCount === 0 ? { visibility: 'hidden' } : null}
                onClick={increaseMonth}
                disabled={nextMonthBtnDisabled}
            >
                <span className='react-datepicker__navigation-icon react-datepicker__navigation-icon--next'>
                    {'>'}
                </span>
            </button>
        </div>
    );
};

export default CustomDatePickerHeader;
